import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Support from './pages/Support';
import SignIn from './pages/SignIn';
import Dashboard from './pages/Dashboard';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

const ADMIN_ROUTES = ['/sign-in', '/dashboard'];

function AppLayout() {
  const location = useLocation();
  const isAdminRoute = ADMIN_ROUTES.includes(location.pathname);

  return (
    <>
      <ScrollToTop />
      <div className="app">
        {!isAdminRoute && <Navigation />}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/support" element={<Support />} />
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
        </Routes>
        {!isAdminRoute && <Footer />}
      </div>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppLayout />
      </AuthProvider>
    </BrowserRouter>
  );
}
